<template>
  <div class="container-main">
    <div class="d-flex justify-space-between">
      <div class="container-main-header-button">
        <v-btn depressed @click="back">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <span>Редактирование</span>
      </div>
      <div></div>
    </div>

    <div class="container-block">
      <div class="container-block-title">Содержание заседания</div>
      <div>
        <v-text-field label="Название" required type="text" outlined v-model="activity.title"></v-text-field>
      </div>

      <div class="d-flex">
        <v-textarea label="Текст" required type="text" outlined v-model="activity.text" no-resize rows="6"></v-textarea>
      </div>
      <div>
        <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="newDate" outlined :rules="rules" readonly label="Дата события" v-bind="attrs"
              v-on="on"></v-text-field>
          </template>

          <v-card class="d-flex">
            <div class="d-flex">
              <v-date-picker v-if="menu" locale="ru-Ru" color="var(--app-dark-blue-1)" v-model="pickDate"
                first-day-of-week="1"></v-date-picker>
            </div>
            <v-time-picker format="24hr" color="var(--app-dark-blue-1)" scrollable :disabled="!pickDate"
              v-model="pickDateTime" width="290"></v-time-picker>
          </v-card>
        </v-menu>
      </div>
    </div>

    <div class="container-block">
      <div class="container-block-title">Отчеты</div>

      <div class="d-flex justify-space-between" v-for="item in files" :key="item.id">
        <div style="width: 47%">
          <v-text-field label="Название" required type="text" outlined v-model="item.name"></v-text-field>
        </div>
        <div class="container-block-file-preview" v-if="typeof item.file == 'string'">
          <v-icon> mdi-file-pdf-box </v-icon>
          <a style="margin-left: 8px" target="_blank" :href="item.file">{{
            item.name
          }}</a>
          <v-icon color="var(--app-red-1)" style="margin-left: 8px" @click="item.file = null">
            mdi-delete-outline
          </v-icon>
        </div>
        <div style="width: 47%" v-else>
          <v-file-input outlined v-model="item.file" label="Прикрепите файл pdf" :rules="[
            (value) =>
              (value && value.size < 104857600) || 'Весом до 100 мб.',
          ]" accept="application/pdf,application/vnd.ms-excel"></v-file-input>
        </div>
      </div>

      <div class="container-block-gallery-button">
        <span @click="addFile">Добавить файл</span>
      </div>
    </div>

    <div v-if="!newImage" class="container-block">
      <div class="container-block-title">Главное изображение</div>

      <v-file-input accept="image/*" outlined :rules="[
        (value) =>
          (value && value.size < 104857600) ||
          'Размер изображения не больше 100 мб',
      ]" hint="Максимальный размер изображения 100 мб" persistent-hint v-model="newImage" @change="previewImage"
        label="Прикрепить изображение"></v-file-input>
      <div class="container-block-gallery-button">
        Выбрать изображение из галереи
      </div>
    </div>

    <div v-if="newImage" class="container-block" style="width: 100%">
      <div class="container-block-title">Изображение</div>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Формат</th>
              <th class="text-left">Место отображенния</th>
              <th class="text-left">Для смартфонов</th>
              <th class="text-left">Для планшетов</th>
              <th class="text-right"></th>
            </tr>
          </thead>
          <tbody>
            <tr style="height: 60px" v-if="newImage">
              <td class="text-left">Изображение</td>
              <td class="text-left">
                Отображается в подробной информации о заседании, над текстом
              </td>
              <td class="text-left">
                <v-btn v-if="!finishImageMobile" @click="openMobileImg(false)" class="button-accept"
                  style="width: auto !important">
                  Кадрировать
                </v-btn>

                <div v-else class="d-flex">
                  <img @click="openMobileImg(false)" class="table-img" :src="finishImageMobile" />
                  <v-btn outlined @click="openMobileImg(false)" color="var(--app-dark-blue-1) "
                    class="button-accept-outlined" style="width: auto !important; margin-left: 10px">
                    Изменить
                  </v-btn>
                </div>
              </td>
              <td class="text-left">
                <v-btn v-if="!finishImageTablet" @click="openTabletImg(false)" class="button-accept"
                  style="width: auto !important">
                  Кадрировать
                </v-btn>
                <div v-else class="d-flex">
                  <img @click="openTabletImg(false)" class="table-img" :src="finishImageTablet" />
                  <v-btn outlined @click="openTabletImg(false)" color="var(--app-dark-blue-1) "
                    class="button-accept-outlined" style="width: auto !important; margin-left: 10px">
                    Изменить
                  </v-btn>
                </div>
              </td>
              <td class="text-left">
                <v-btn icon @click="deleteImage">
                  <v-icon color="var(--app-red-1)"> mdi-delete-outline </v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-alert color="var(--app-red-1)" type="error" v-model="errImages">
        Откадрируйте изображения для всех типов устройств
      </v-alert>
      <v-divider></v-divider>

      <v-dialog width="800px" height="auto" persistent v-if="imgSrc" v-model="dialogMobile">
        <v-card width="800px" height="auto" class="rounded-0">
          <v-card-title class="dialog-title">
            <span class="title">Кадрирование изображения</span>
            <v-icon @click="dialogMobile = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-subtitle">
              <div class="dialog-subtitle-title">
                Отображение на мобильном устройстве
              </div>
              <div class="dialog-subtitle-text">
                Вы можете изменять размер изображения с помощью колесика мыши и
                двигать его.
              </div>
            </div>

            <div v-if="imgSrc" class="d-flex justify-space-between">
              <div style="width: 380px; height: 380px">
                <cropper ref="cropperMobail" :src="imgSrc" style="width: 450px; height: 450px" :stencil-props="{
                  handlers: {},
                  movable: false,
                  scalable: true,
                }" :stencil-size="{
  width: 343,
  height: 206,
}" image-restriction="stencil" @change="onChangeMobile" />
              </div>

              <div style="width: 100%" class="d-flex justify-center" v-if="resultImageMobile">
                <img width="343px" height="206px" :src="resultImageMobile" />
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="closeMobileImg()" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog width="800px" height="auto" persistent v-if="imgSrc" v-model="dialogTablet">
        <v-card width="800px" height="auto" class="rounded-0">
          <v-card-title class="dialog-title">
            <span class="title">Кадрирование изображения</span>
            <v-icon @click="dialogTablet = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-subtitle">
              <div class="dialog-subtitle-title">Отображение на планшете</div>
              <div class="dialog-subtitle-text">
                Вы можете изменять размер изображения с помощью колесика мыши и
                двигать его.
              </div>
            </div>

            <div v-if="imgSrc" class="">
              <div style="width: 100%; height: 200px">
                <cropper ref="cropperTablet" :src="imgSrc" style="width: 100%; height: 300px" :stencil-props="{
                  handlers: {},
                  movable: false,
                  scalable: true,
                }" :stencil-size="{
  width: 658,
  height: 374,
}" image-restriction="stencil" @change="onChangeTablet" />
              </div>

              <div class="dialog-tablet-img" v-if="resultImageTablet">
                <img width="658px" height="374px" :src="resultImageTablet" />
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="closeTabletImg()" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-alert color="var(--app-red-1)" type="error" v-model="errImagesMain">
      Прикрепите изображение
    </v-alert>

    <div class="container-block-footer-buttons">
      <div>
        <v-btn @click="saveActivity" style="width: auto !important" class="button-accept">
          Сохранить
        </v-btn>
      </div>
      <div>
        <v-btn @click="dialogDelete = true" outlined style="width: auto !important" color="var(--app-red-1)"
          class="button-accept-outlined">
          Удалить
        </v-btn>
      </div>
    </div>

    <v-dialog width="600px" height="auto" persistent v-model="dialogDelete">
      <v-card>
        <v-card-title class="dialog-title">
          <span class="title">Точно хотите удалить заседание?</span>
          <v-icon @click="dialogDelete = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-actions class="dialog-buttons">
          <v-btn @click="dialogDelete = false" style="width: 120px" outlined color="var(--app-green-1)">
            Нет
          </v-btn>
          <v-btn @click="deleteMeeting" style="width: 120px" outlined color="var(--app-red-1)">
            Да
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default {
  components: {
    Cropper,
  },
  data: () => ({
    activity: {},

    errImages: false,
    errImagesMain: false,
    dialogMobile: false,

    dialogTablet: false,
    menu: false,
    newDate: null,
    pickDate: null,
    pickDateTime: "00:00",
    dialogDelete: false,

    rules: [(value) => !!value || "Обязательно к заполнению"],

    newImage: null,
    imgSrc: "",

    resultImageMobile: "",
    resultImageTablet: "",

    finishImageMobile: "",
    finishImageTablet: "",

    smartphoneMainImage: null,
    tabletMainImage: null,

    files: [],
    formData: new FormData(),
  }),

  methods: {
    deleteMeeting() {
      this.$axios
        .delete(this.$store.getters.apiAdminPanelV2 + "/activity/meeting", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
          params: {
            meetingId: this.$route.params.id,
          },
        })
        .then(() => {
          this.$router.push({
            name: "CouncilActivity",
            params: { selectedTicker: 1 },
          });
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    deleteItem(item) {
      const newArr = this.files.filter((i) => i.file != item.file);
      this.files = newArr;
    },
    addFile() {
      const newObj = {
        name: "",
        file: null,
      };
      this.files.push(newObj);
    },

    deleteImage() {
      this.newImage = null;
      this.imgSrc = "";
      this.resultImageMobile = "";
      this.resultImageTablet = "";
      this.finishImageMobile = "";
      this.finishImageTablet = "";
      this.smartphoneMainImage = null;
      this.tabletMainImage = null;
    },

    openMobileImg() {
      this.dialogMobile = true;
      setTimeout(() => {
        this.$refs.cropperMobail.refresh();
      }, 500);

      this.errImages = false;
    },
    openTabletImg() {
      this.dialogTablet = true;
      setTimeout(() => {
        this.$refs.cropperTablet.refresh();
      }, 500);

      this.errImages = false;
    },
    closeTabletImg() {
      this.finishImageTablet = this.resultImageTablet;
      this.dialogTablet = false;
      const { canvas } = this.$refs.cropperTablet.getResult();
      canvas.toBlob(
        (blob) => {
          this.formData.append("tabletImage", blob);
        },
        "image/webp",
        0.95
      );
      this.tabletMainImage = true;
    },

    closeMobileImg() {
      this.finishImageMobile = this.resultImageMobile;
      this.dialogMobile = false;
      const { canvas } = this.$refs.cropperMobail.getResult();
      canvas.toBlob(
        (blob) => {
          this.formData.append("smartphoneImage", blob);
        },
        "image/webp",
        0.95
      );
      this.smartphoneMainImage = true;
    },

    back() {
      this.$router.push({
        name: "CouncilActivity",
        params: { selectedTicker: 1 },
      });
    },

    previewImage() {
      if (this.newImage) {
        this.imgSrc = URL.createObjectURL(this.newImage);
      } else {
        this.imgSrc = "";
      }
    },

    defaultSize({ imageSize }) {
      return {
        width: Math.min(imageSize.height, imageSize.width),
        height: Math.min(imageSize.height, imageSize.width),
      };
    },

    onChangeMobile({ canvas }) {
      this.resultImageMobile = canvas.toDataURL();
    },

    onChangeTablet({ canvas }) {
      this.resultImageTablet = canvas.toDataURL();
    },
    getMeeting() {
      this.$axios
        .get(this.$store.getters.apiAdminPanelV2 + "/activity/meeting", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
          params: {
            meetingId: this.$route.params.id,
          },
        })
        .then((res) => {
          this.activity = res.data;
          this.files = res.data.files;

          this.newImage = this.activity.originalImage;
          this.imgSrc = this.activity.originalImage;
          this.smartphoneMainImage = this.activity.smartphoneImage;
          this.tabletMainImage = this.activity.tabletImage;
          this.activity.smartphoneImage
            ? (this.finishImageMobile = this.activity.smartphoneImage)
            : "";
          this.activity.tabletImage
            ? (this.finishImageTablet = this.activity.tabletImage)
            : "";

          const date = new Date(this.activity.date);
          this.pickDate = new Date(
            this.activity.date - date.getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);
          let hour = date.getHours();
          let minute = date.getMinutes();
          if (hour < 10) {
            hour = `0${hour}`;
          }
          if (minute < 10) {
            minute = `0${minute}`;
          }
          this.pickDateTime = `${hour}:${minute}`;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },

    saveActivity() {
      if (this.newImage) {
        if (this.smartphoneMainImage && this.tabletMainImage) {
          this.errImages = false;
          const newArr = Array.from(this.files).filter((item) => item.file);
          const newArrFiles = newArr
            .map((i) => {
              return typeof i.file == "object" ? i.file : null;
            })
            .filter((el) => {
              return el != null;
            });
          const newArrNames = newArr.map((i) => {
            if (typeof i.file == "object") {
              i.file = "";
              return i;
            } else {
              return i;
            }
          });
          const validDate = this.pickDate + "T" + this.pickDateTime;
          const date = new Date(validDate).getTime();

          this.formData.append("meetingId", this.activity.id);
          this.formData.append("title", this.activity.title);
          this.formData.append("text", this.activity.text);
          this.formData.append("date", date);

          for (let index = 0; index < newArrFiles.length; index++) {
            const element = newArrFiles[index];
            this.formData.append("files", element);
          }
          this.formData.append("files", JSON.stringify(newArrNames));

          this.formData.append("originalImage", this.newImage || null);

          this.$axios
            .post(
              this.$store.getters.apiAdminPanelV2 + "/activity/meeting",
              this.formData,
              {
                headers: {
                  authorization: this.$store.getters.adminPanelHeaderAuth,
                },
              }
            )
            .then(() => {
              this.$router.push({
                name: "CouncilActivity",
                params: { selectedTicker: 1 },
              });
            })
            .catch((err) => {
              this.$store.commit("errorSet", true);
              this.$store.commit("errorTextSet", err);
            });
        } else {
          this.errImages = true;
        }
      } else {
        this.errImagesMain = true;
      }
    },
  },
  created() {
    this.getMeeting();
  },

  watch: {
    newImage() {
      if (this.newImage) {
        this.errImagesMain = false;
      }
    },
    pickDate() {
      const date = this.formatDate(this.pickDate);
      this.newDate = date + " " + this.pickDateTime;
    },
    pickDateTime() {
      if (this.pickDate) {
        const date = this.formatDate(this.pickDate);
        this.newDate = date + " " + this.pickDateTime;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.switch-label {
  font-size: 16px;

  margin-bottom: 2px;
}

.container-main {
  box-sizing: border-box;

  padding: 40px !important;

  .container-main-header-button {
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    span {
      font-size: 28px;
      font-weight: 400;
      margin-left: 16px;
    }
  }

  .container-block {
    width: 50%;
    margin-bottom: 20px;

    .container-block-title {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 16px;
    }

    .container-block-gallery-button {
      text-decoration: underline;
      color: #1064dd;
      font-size: 18px;
      font-weight: 400;
      cursor: pointer;
      padding-bottom: 20px;
    }

    .table-img {
      // width: 62px;
      height: 38px;
      object-fit: contain;
    }

    .container-main-checkbox {
      border: 1px solid rgba(0, 0, 0, 0.42);
      border-radius: 4px;
      padding-top: 20px;
      padding-left: 12px;
      margin-top: 0px !important;
    }

    .container-block-file-preview {
      width: 47%;
      height: 56px;
      display: flex;
      align-items: center;
    }
  }

  .container-block-footer-buttons {
    display: flex;
    justify-content: space-between;
    width: 50%;
    margin-top: 60px;
  }
}

.dialog-tablet-img {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  img {
    width: 658;
    height: 192;
  }
}
</style>